import "./product-dimension";

class PdpProductDimensions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.toggle = this.querySelector("[data-toggle]");
    this.content = this.querySelector("[data-content]");

    this.toggle.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });
  }

  disconnectedCallback() {
  }

  open() {
    if (this.isOpen) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);

    this.content.style.display = 'block';
    this.content.setAttribute('aria-hidden', 'false');
    this.content.classList.add("open");

    this.toggle.setAttribute('aria-expanded', 'true');

    if (this.content) {
      this.content.style.height = 0;

      this.handleTransitionEnd = (e) => {
        if (e.target !== this.content) return;

        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.height = null;
        this.content.style.overflow = "visible";
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
      });
    }
  }

  close() {
    if (!this.isOpen || !this.content) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);

    this.content.style.height = `${this.content.scrollHeight}px`;

    window.requestAnimationFrame(() => {
      this.handleTransitionEnd = (e) => {
        if (e.target !== this.content) return;

        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.display = 'none';
        this.content.setAttribute('aria-hidden', 'true');
        this.content.style.height = null;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.classList.remove("open");
      this.toggle.setAttribute('aria-expanded', 'false');
      this.content.style.height = 0;
      this.content.style.overflow = null;
    });
  }

  get isOpen() {
    return this.content.getAttribute('aria-hidden') === 'false';
  }
}

if (!customElements.get("pdp-product-dimensions")) {
  customElements.define("pdp-product-dimensions", PdpProductDimensions);
}
